<script setup>
  import { computed, inject } from 'vue';
  import ToggleItemUpgrade from "@/components/controls/ToggleItemUpgrade.vue";
  import Icon from "@/components/icons/Icon.vue";
  const model = defineModel();

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number, Array, Object],
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    onChangeCallback: {
      type: Function,
      required: false
    },
    trueValue: {
      type: [String, Number],
      validator(value, props) {       
        return props.inputType === 'checkbox' && props.falseValue && value;
      }
    },
    falseValue: {
      type: [String, Number],
      validator(value, props) {       
        return props.inputType === 'checkbox' && props.trueValue && value;
      }
    },
    inputType: {
      type: String,
      default: 'checkbox'
    } ,
    iconName: {
      type: String,
      required: false
    },
    hasUpgrade: {
      type: Boolean,
      required: false
    },
    smallText: {
      type: Boolean,
      default: false
    },
    eventHandler: {
      type: Function,
      required: false
    },
    elementType: {
      type: String,
      default: 'div'
    }
  });

  const inputName = computed(() => props.name || props.id);

  // Provided by ToggleList
  const elementType = inject('elementType', props.elementType);

  const handleOnChange = () => {
    if (props.onChangeCallback) {
      props.onChangeCallback(model.value);
    }
  }

</script>

<template>
  <ToggleItemUpgrade
    v-if="hasUpgrade"
    :iconName="iconName"
    :isDisabled="props.disabled"
  >
    <slot></slot>
  </ToggleItemUpgrade>
  <component v-else :is="!elementType || elementType === 'div' ? 'div' : 'li'" class="jwx-toggle">
    <input v-if="props.trueValue"
      @change="handleOnChange"
      :type="props.inputType"
      :name="inputName"
      :id="props.id" 
      :disabled="props.disabled"
      :true-value="props.trueValue"
      :false-value="props.falseValue"
      v-model="model"
      class="jwc-toggle-input" 
    />
    <input v-else
      @change="handleOnChange"
      :type="props.inputType"
      :name="inputName"
      :id="props.id" 
      :value="value"
      :disabled="props.disabled"
      v-model="model"
      class="jwc-toggle-input" 
    />
    <label class="jwc-toggle-label" :for="props.id">
      <div class="jwx-toggle__label-icon">
        <Icon v-if="iconName" :name="iconName" />
      </div>
      <span
        class="jwc-toggle-label-text"
        :class="props.smallText ? 'jwc-toggle-label-text--small' : null"
      >
        <slot></slot>
      </span>
      <div class="jwc-toggle-switch"></div>
    </label>
  </component>
</template>